import React, { Component } from 'react';

class Error extends Component {
    state = {  }
    render() { 
        return (<div><p><h2>This page was not found.</h2></p></div>  );
    }
}
 
export default Error;